// Wave UX-2.4 #14 (2026-05-24) — 공용 빈 상태 컴포넌트.
// 8+ 페이지 (AuctionList / BidsList / FavoritesList / PromiseList / Notifications / Chat / Dashboard) 통합.
//
// Props:
//   icon       — emoji or React node (ex: '🚗' / '🔍' / '⭐') — 사이즈는 48px 자동
//   title      — 굵은 1줄 제목 (필수)
//   hint       — 보조 안내 (선택, 작은 회색 텍스트)
//   action     — { label, onClick } CTA 버튼 (선택)
//   minHeight  — 영역 높이 (선택, 기본 240px)

import React from 'react';

function EmptyState(props) {
  var icon = props.icon;
  var title = props.title;
  var hint = props.hint;
  var action = props.action;
  var minHeight = props.minHeight || 240;

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: minHeight,
      padding: '24px 16px',
      textAlign: 'center',    }}>
      {icon && (
        <div style={{
          fontSize: 48, lineHeight: 1,
          opacity: 0.6,
          marginBottom: 14,
        }}>{icon}</div>
      )}
      {title && (
        <div style={{
          fontSize: 15, fontWeight: 700, color: '#475569',
          marginBottom: hint ? 6 : 0,
          maxWidth: 320, lineHeight: 1.4,
        }}>{title}</div>
      )}
      {hint && (
        <div style={{
          fontSize: 13, color: '#94a3b8',
          maxWidth: 320, lineHeight: 1.5,
        }}>{hint}</div>
      )}
      {action && action.onClick && (
        <button type="button" onClick={action.onClick}
          style={{
            marginTop: 18,
            padding: '10px 22px',
            background: 'linear-gradient(135deg, #1B3A5C 0%, #3b82f6 100%)',
            color: 'white', border: 'none', borderRadius: 10,
            fontSize: 13, fontWeight: 700, cursor: 'pointer',            boxShadow: '0 4px 12px rgba(27,58,92,0.2)',
          }}>
          {action.label}
        </button>
      )}
    </div>
  );
}

export default EmptyState;
